// extracted by mini-css-extract-plugin
export default {"footerLinks":"FooterLinks_footerLinks__xS5Xy","bottomLabel":"FooterLinks_bottomLabel__fEZ5r","bottomFooter":"FooterLinks_bottomFooter__PetlF"};